import { Box, Stack, Typography, useTheme } from "@mui/material";
import { ProgressTimelineDot } from "./ProgressTimelineDot";
import { useTranslations } from "next-intl";

interface ProgressTimelineItemProps {
  isActive: boolean;
  isCompleted: boolean;
  title: string;
  subTitle: string;
  hideConnector?: boolean;
  onClick?: () => void;
}

export const ProgressTimelineItem = ({
  isActive,
  isCompleted,
  title,
  subTitle,
  hideConnector,
  onClick,
}: ProgressTimelineItemProps) => {
  const theme = useTheme();
  const t = useTranslations();
  return (
    <Stack
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent="center"
      sx={{ cursor: "pointer" }}
      flexDirection={{ xs: "row", md: "column" }}
      onClick={onClick}
    >
      {!hideConnector && (
        <Box
          height={{ xs: "0.125rem", md: "2rem" }}
          width={{ xs: "0.8rem", md: "0.125rem" }}
          borderRadius="0.125rem"
          bgcolor={
            isActive || isCompleted
              ? theme.palette.primary.main
              : theme.palette.grey[300]
          }
          mt={{ xs: "0.5rem", md: "0.2rem " }}
          mb="0.8rem"
        />
      )}
      <Stack alignItems="center">
        <ProgressTimelineDot isCompleted={isCompleted} isActive={isActive} />
        <Typography
          color={isActive ? "primary" : "grey.200"}
          fontSize={{ xs: "0.65rem", md: "0.875rem" }}
          fontWeight="700"
          mt={0.4}
          px={0.5}
          textAlign="center"
          textTransform="capitalize"
        >
          {t(title)}
        </Typography>
        <Typography
          height={{ xs: "3rem", md: "auto" }}
          color="grey.200"
          fontSize="0.875rem"
          display={{ xs: "none", md: "block" }}
          textAlign="center"
        >
          {t(subTitle)}
        </Typography>
      </Stack>
    </Stack>
  );
};
